import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  IInjectedDrawerProps,
  INotificationsDrawerProps,
  notificationsDrawerListSelector,
} from "@ryde/shared";

import {
  DrawerContentStyled,
  DrawerEntityDataLoader,
  MenuBaseDrawer,
} from "../drawer";
import { NotificationItem, NotificationsDrawerListStyled } from "./components";
import { useNotificationsDrawer } from "./hooks";
import { NotificationHeader } from "./notification-header";

export const NotificationsDrawer: FC<
  INotificationsDrawerProps & IInjectedDrawerProps
> = ({ onCloseDrawer }) => {
  const { t } = useTranslation();
  const notificationsDrawerList = useRecoilValue(
    notificationsDrawerListSelector,
  );
  const { isLoading } = useNotificationsDrawer();

  return (
    <MenuBaseDrawer onCloseDrawer={onCloseDrawer}>
      <NotificationHeader onClose={onCloseDrawer} />

      <DrawerContentStyled>
        <NotificationsDrawerListStyled>
          {isLoading && <DrawerEntityDataLoader entityTitle="notification" />}
          {!isLoading && !notificationsDrawerList.length && (
            <h3 className="NotificationsDrawer-NoNotificationFound">
              {t("notification.NO_NOTIFICATION_FOUND")}
            </h3>
          )}

          {!isLoading &&
            notificationsDrawerList.map(notification => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                onCloseDrawer={onCloseDrawer}
              />
            ))}
        </NotificationsDrawerListStyled>
      </DrawerContentStyled>
    </MenuBaseDrawer>
  );
};
